import {
    MERCHANT_REPORT_INITIATED,
    MERCHANT_REPORT_LOADED,
    MERCHANT_REPORT_FAILED,
    MERCHANT_SUMMARY_INITIATED,
    MERCHANT_SUMMARY_LOADED,
    MERCHANT_SUMMARY_FAILED,
    MERCHANT_REPORT_GENERATE_INITIATED,
    MERCHANT_REPORT_GENERATE_LOADED,
    MERCHANT_REPORT_GENERATE_FAILED
} from "../actions/MerchantReportAction";
  
const initialState = {
    listdata: [],
    summarydata: [],
    data: [],
    pagination: {
      total: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
      nextPage: null,
    },
    summarypagination: {
      total: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
      nextPage: null,
    },
    loading: false,
    error: null
};
  
const MerchantReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case MERCHANT_REPORT_INITIATED:
        return {
          ...state,
          data : {},
          loading: true,
          error: null,
        };
      case MERCHANT_REPORT_LOADED:
        return {
          ...state,
          loading: false,
          data : {},
          listdata: action.payload.data,
          pagination: action.payload.pagination,
        };
      case MERCHANT_SUMMARY_INITIATED:
        return {
          ...state,
          summarydata : [],
          loading: true,
          error: null,
        };
      case MERCHANT_SUMMARY_LOADED:
        return {
          ...state,
          loading: false,
          data : {},
          summarydata: action.payload.data,
          summarypagination: action.payload.pagination,
        };
      case MERCHANT_REPORT_FAILED:
          return { ...state, loading: false, error: action.payload };
      case MERCHANT_REPORT_GENERATE_INITIATED:
          return { ...state,  loading: true};
      case MERCHANT_REPORT_GENERATE_LOADED:
          return { ...state, merchantCount: action.payload, loading: false };
      case MERCHANT_REPORT_GENERATE_FAILED:
          return { ...state , loading: false };
      default:
        return state;
    }
};
  
export default MerchantReportReducer;